import axios from 'axios'
import { Fragment, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonOutline from 'src/components/atoms/ButtonOutline'
import CardArticle from 'src/components/molecules/CardArticle'
import SubscribeFlotaing from 'src/components/molecules/SubscribeFloating'
import CardLoader from 'src/components/orgainsms/CardProduct/CardLoader'
import SecondHeader from 'src/components/orgainsms/SecondHeader'
import useSwr from 'swr'

const fether = async url => {
  const response = await axios(url)
  return response.data
}

const ArticleList = () => {
  const navigate = useNavigate()
  const API = process.env.REACT_APP_API
  const { data, isLoading } = useSwr(API + '/article', fether)
  const [keyword, setKeyword] = useState('')

  const handleSearch = () => {
    navigate({
      pathname: '/articles/search/' + keyword
    })
  }

  const goToPage = path => {
    navigate('/articles/category/' + path)
  }

  return (
    <>
      <SecondHeader
        onSearch={handleSearch}
        onChange={e => setKeyword(e.target.value)}
      />

      <div className='px-4 lg:px-8 pt-6 pb-32 max-w-screen-xl mx-auto'>
        {isLoading && (
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-5'>
            {[1,2,3,4,5,6,7,8].map(item => (
              <CardLoader key={item} />
            ))}
          </div>
        )}

        {data?.map(item => (
          <Fragment key={item.id}>

            {item.title === 'Trivia' && (
              <div className='mb-[12px] lg:mb-[120px]'>
                <div className='py-8 flex justify-between items-end'>
                  <h2 className='text-[#006c63] text-[24px]'>Trivia</h2>
                  <ButtonOutline
                    onClick={() => goToPage(item.slug)}
                    title='see more...'
                  />
                </div>

                <div className='grid grid-cols-2 lg:grid-cols-4 gap-[10px] md:gap-[30px]'>
                  {item.articles.map(art => (
                    <CardArticle
                      key={art.id}
                      publishedAt={art.published_at}
                      title={art.title}
                      slug={`/articles/${art.slug}`}
                      image={`${process.env.REACT_APP_IMAGE}/article/${art.image}`}
                    />
                  ))}
                </div>
              </div>
            )}

            {item.title === 'Technology' && (
              <div className='mb-[12px] lg:mb-[120px]'>
                <div className='py-8 flex justify-between items-end'>
                  <h2 className='text-[#006c63] text-[24px]'>Technology</h2>
                  <ButtonOutline
                    onClick={() => goToPage(item.slug)}
                    title='see more...'
                  />
                </div>

                {(() => {
                  const articles = Array.isArray(item.articles) ? item.articles : []
                  if (articles.length === 0) return null

                  const highlight = articles[0]
                  const rest = articles.slice(1, 8)

                  return (
                    <div className='grid lg:grid-cols-3 lg:grid-rows-3 gap-8 lg:gap-10'>

                      <div className='lg:row-span-2'>
                        <CardArticle
                          highlight
                          publishedAt={highlight.published_at}
                          title={highlight.title}
                          slug={`/articles/${highlight.slug}`}
                          image={`${process.env.REACT_APP_IMAGE}/article/${highlight.image}`}
                        />
                      </div>

                      {rest.slice(0, 4).map(art => (
                        <CardArticle
                          key={art.id}
                          type='horizontal'
                          publishedAt={art.published_at}
                          title={art.title}
                          slug={`/articles/${art.slug}`}
                          image={`${process.env.REACT_APP_IMAGE}/article/${art.image}`}
                        />
                      ))}

                      {rest.slice(4, 7).map(art => (
                        <CardArticle
                          key={art.id}
                          type='horizontal'
                          publishedAt={art.published_at}
                          title={art.title}
                          slug={`/articles/${art.slug}`}
                          image={`${process.env.REACT_APP_IMAGE}/article/${art.image}`}
                        />
                      ))}
                    </div>
                  )
                })()}
              </div>
            )}

            {item.title === 'Bussiness' && (
              <div className='mb-[12px] lg:mb-[120px]'>
                <div className='py-8 flex justify-between items-end'>
                  <h2 className='text-[#006c63] text-[24px]'>Bussiness</h2>
                  <ButtonOutline
                    onClick={() => goToPage(item.slug)}
                    title='see more...'
                  />
                </div>

                <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-12'>
                  {item.articles.map(art => (
                    <CardArticle
                      key={art.id}
                      type='horizontal'
                      publishedAt={art.published_at}
                      title={art.title}
                      slug={`/articles/${art.slug}`}
                      image={`${process.env.REACT_APP_IMAGE}/article/${art.image}`}
                    />
                  ))}
                </div>
              </div>
            )}

          </Fragment>
        ))}
      </div>

      <SubscribeFlotaing />
    </>
  )
}

export default ArticleList
